import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse, X9Content, X9ContentUpdateModel} from '../../../../domain';
import {HttpPromiseState, SaveStateHolder} from '../../../../lib/helpers';
import {X7PushableBlockStore} from '../X7PushableBlockStore';


export class EditContentStore implements SaveStateHolder {
  @observable
  valid: boolean;

  @observable
  contents: string;

  @observable
  touched: boolean;

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(private readonly parent: X7PushableBlockStore,
              readonly content: X9Content) {
    makeObservable(this);
    this.valid = true;
    this.contents = content.Contents;
    this.touched = false;
    this.save = null;
  }

  @action
  setValid = (valid: boolean) => {
    this.valid = valid;
  };

  @action
  setContents = (value: string) => {
    this.contents = value;
  };

  @action
  markTouched = () => {
    this.touched = true;
  };

  @action
  complete = () => {
    if (this.save?.isPending === true)
      return;
    this.markTouched();
    if (!this.valid)
      return;
    let model: X9ContentUpdateModel = {
      BlockId: this.content.BlockId,
      ContentType: this.content.ContentType,
      Contents: this.contents,
      Index: this.content.Index
    };
    this.save = contentLoaders.x9content.update(this.content.Id, model);
  };

  @action
  cancel = () => {
    this.parent.cancel();
  }
}
